import { RogersBankService } from './rogers-bank.service';
import { RogersBankAuthRequest } from '@rogers/self-serve-rogers-bank';
import { ApiEndpointService } from '@rci/self-serve-shared';

class RogersBankConfigFactory {
  constructor(
    private readonly rogerBankService: RogersBankService,
    private readonly apiEndpointService: ApiEndpointService,
  ) {}

  get promotionsBaseUrlV3() {
    return this.apiEndpointService.promotionsBaseUrlV3;
  }

  authenticateUser$(authRequest: RogersBankAuthRequest) {
    return this.rogerBankService.authenticateUser$(authRequest);
  }
}

export const rogersBankConfigFactory = (
  rogerBankService: RogersBankService,
  apiEndpointService: ApiEndpointService,
) => {
  return new RogersBankConfigFactory(rogerBankService, apiEndpointService);
};
